module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/afore38-8fdb9c1e59a69f2e727f9638aa94a146.jpg";